export default __webpack_public_path__ + "6bf711977cd2fbcafc429155d589d4f4.svg";